import api from '../../Axios'; // Adjust path to your Axios instance

// 🟢 STEP 3: Save Doctor Identity Proof
// Endpoint: /api/experts/doctor/identity
export const saveDoctorIdentity = async (formData: FormData) => {
  return api.post('/api/experts/doctor/identity', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};